import { createContext, useContext } from 'react';
import AccountStore from './accountStore';
import AddressStore from './addressStore';
import AuthenticationStore from './authenticationStore';
import AvailabilityStore from './AvailabilityStore';
import ConcernStore from './concernStore';
import CustomerStore from './customerStore';
import DocumentStore from './documentStore';
import InspectionStore from './inspectionStore';
import InvoiceStore from './invoiceStore';
import OrderStore from './orderStore';
import PaymentStore from './paymentStore';
import ReminderStore from './reminderStore';
import RequestStore from './requestStore';
import RoleStore from './roleStore';
import ServiceGroupStore from './serviceGroupStore';
import ServiceHistoryStore from './serviceHistoryStore';
import ServiceStore from './serviceStore';
import SessionStore from './sessionStore';
import TechnicalCategoryStore from './technicalCategoryStore';
import TenantProfileStore from './tenantProfileStore';
import TenantStore from './tenantStore';
import UnavailabilityStore from './unavailabilityStore';
import UserStore from './userStore';
import VehicleStore from './vehicleStore';
import SmsTemplateStore from './smsTemplateStore';
import CreditStore from './creditStore';
import InventoryStore from './inventoryStore';
import SupplierStore from './supplierStore';
import TwoFactorStore from './twoFactorStore';

interface Store {
  authenticationStore: AuthenticationStore;
  roleStore: RoleStore;
  tenantStore: TenantStore;
  tenantProfileStore: TenantProfileStore;
  userStore: UserStore;
  sessionStore: SessionStore;
  accountStore: AccountStore;
  serviceStore: ServiceStore;
  serviceGroupStore: ServiceGroupStore;
  customerStore: CustomerStore;
  vehicleStore: VehicleStore;
  orderStore: OrderStore;
  invoiceStore: InvoiceStore;
  technicalCategoryStore: TechnicalCategoryStore;
  concernStore: ConcernStore;
  requestStore: RequestStore;
  documentStore: DocumentStore;
  addressStore: AddressStore;
  reminderStore: ReminderStore;
  unavailabilityStore: UnavailabilityStore;
  availabilityStore: AvailabilityStore;
  serviceHistoryStore: ServiceHistoryStore;
  paymentStore: PaymentStore;
  inspectionStore: InspectionStore;
  smsTemplateStore: SmsTemplateStore;
  creditStore: CreditStore;
  inventoryStore: InventoryStore;
  supplierStore: SupplierStore;
  twoFactorStore: TwoFactorStore;
}

export const stores: Store = {
  authenticationStore: new AuthenticationStore(),
  roleStore: new RoleStore(),
  tenantStore: new TenantStore(),
  tenantProfileStore: new TenantProfileStore(),
  userStore: new UserStore(),
  sessionStore: new SessionStore(),
  accountStore: new AccountStore(),
  serviceStore: new ServiceStore(),
  serviceGroupStore: new ServiceGroupStore(),
  customerStore: new CustomerStore(),
  vehicleStore: new VehicleStore(),
  orderStore: new OrderStore(),
  invoiceStore: new InvoiceStore(),
  technicalCategoryStore: new TechnicalCategoryStore(),
  concernStore: new ConcernStore(),
  requestStore: new RequestStore(),
  documentStore: new DocumentStore(),
  addressStore: new AddressStore(),
  reminderStore: new ReminderStore(),
  unavailabilityStore: new UnavailabilityStore(),
  availabilityStore: new AvailabilityStore(),
  serviceHistoryStore: new ServiceHistoryStore(),
  paymentStore: new PaymentStore(),
  inspectionStore: new InspectionStore(),
  smsTemplateStore: new SmsTemplateStore(),
  creditStore: new CreditStore(),
  inventoryStore: new InventoryStore(),
  supplierStore: new SupplierStore(),
  twoFactorStore: new TwoFactorStore(),
};

export const StoreContext = createContext(stores);

export function useStore() {
  return useContext(StoreContext);
}
